import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="dark-footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-section footer-brand">
            <div className="footer-logo">Discover Business Class</div>
            <p className="footer-tagline">
              Upgrading businesses from economy to excellence.
            </p>
            <div className="footer-contact-info">
              <a href="mailto:hello@discoverbusiness-class.com" className="footer-contact-link">
                <Mail size={18} />
                <span>hello@discoverbusiness-class.com</span>
              </a>
              <a href="tel:+13074272444" className="footer-contact-link">
                <Phone size={18} />
                <span>+1 307-427-2444</span>
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h3 className="footer-heading">Services</h3>
            <ul className="footer-links">
              <li><Link to="/consulting">Consulting</Link></li>
              <li><Link to="/consulting">Operations Optimization</Link></li>
              <li><Link to="/consulting">Sales Systems</Link></li>
              <li><Link to="/consulting">Customer Experience</Link></li>
              <li><Link to="/consulting">Team Training</Link></li>
            </ul>
          </div>

          {/* Community */}
          <div className="footer-section">
            <h3 className="footer-heading">Community</h3>
            <ul className="footer-links">
              <li><Link to="/community">Membership Tiers</Link></li>
              <li><Link to="/community">Free Membership</Link></li>
              <li><Link to="/community">Pro Membership</Link></li>
              <li><Link to="/community">Inner Circle</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="footer-section">
            <h3 className="footer-heading">Company</h3>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/contact">Book a Call</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Discover Business Class. All rights reserved.
          </p>
          <div className="footer-legal">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
